import React from "react";

class Banner extends React.Component {
  render() {
    const firstItemPath = {
      background: "url(/images/110618-005.jpg)"
    };
    const vertical = {
      paddingLeft: "10%"
    };

    const paddingStyle = {
      paddingLeft: "10%",
      textAlign: "right",
      paddingRight: "10%"
    };

    const paddingLeftStyle = {
      paddingLeft: "10%"
    };
    return (
        <section className="header_section header_section_promo">
          {/* <div className="bg-overlay" / >*/}
          <div className="container">
            <div className="row">

              <div className="col-lg-10 text-w">
                <div className="desktop-header">
                  <h1 className="sub no-margin bold600 mb-3 text-w">U.S. Data Pricing</h1>{/*<span >(effective 1/1/2021)</span>*/}
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/newpricing/Banner.js